<template>
  <div
    v-if="!loading"
    ref="passDetail"
    class="pass-detail"
  >
    <detail-header
      ref="header"
      :crumb="showCrumb"
      :menu-datas="menuDatas"
      :code="code"
      :inquiry-id="inquiryId"
      @backList="goBackList"
      @handleApply="handleApply"
    />
    <!-- 回收保存后的提示 -->
    <div ref="alertRef">
      <a-alert
        v-if="recycleLogTips"

        :message="recycleLogTips"
        type="info"
        show-icon
        class="common-alert-info"
      >
        <i
          slot="icon"
          class="iconfont iconicon-test34"
        />
      </a-alert>
    </div>
    <div
      v-if="!loading && Object.keys(detailData).length > 0"
      ref="container"
      class="container"
      :class="{'no-permission': !permissionInfo.is_show_inquirydetail}"
    >
      <!-- 概览 -->
      <member-module ref="memberModule" />
      <div
        v-if="permissionInfo.is_show_inquirydetail"
        ref="containerInner"
        class="inner clearfix"
      >
        <div
          v-if="permissionInfo.is_show_followups === 1 || permissionInfo.is_show_comments === 1"
          ref="containerRight"
          class="container-right"
          :class="{
            fullContainer: !permissionInfo.is_show_inquirydetail && !permissionInfo.is_show_fromdetail && !permissionInfo.is_show_historys,
            hide: isFold
          }"
        >
          <right-tabs
            ref="rightTabs"
          />
        </div>
        <div
          v-if="permissionInfo.is_show_inquirydetail === 1 || permissionInfo.is_show_fromdetail === 1 || permissionInfo.is_show_historys === 1"
          ref="containerLeft"
          class="container-left"
          :class="{
            fullContainer: !permissionInfo.is_show_followups && !permissionInfo.is_show_comments || isFold
          }"
        >
          <!-- 审核通过的询盘详情 -->
          <left-tabs
            ref="leftTabs"
            :form-data="formData"
          />
          <a-popover overlay-class-name="fold-box">
            <template slot="content">
              <p v-if="!isFold">
                点我可以收起右侧界面哦
              </p>
              <p v-else>
                点我可以展开右侧界面哦
              </p>
            </template>
            <div
              class="fold-btn"
              :class="{ 'open': isFold, 'close': !isFold }"
              @click="isFold = !isFold"
            >
              <i
                class="iconfont"
                :class="{ 'iconicon-test73': !isFold, 'iconicon-test43': isFold }"
              />
            </div>
          </a-popover>
        </div>
      </div>
    </div>
    <div
      v-else-if="!loading && Object.keys(detailData).length === 0"
      class="spin-fixed-center no_data"
    >
      <p><i class="iconfont iconicon-test38 logo" /></p>
      <p>
        {{ $t('message["343"]') }}
      </p>
    </div>
    <a-spin
      v-else
      class="spin-fixed-center"
    />
    <!-- 申请重新分配弹窗 -->
    <apply-modal
      :visible.sync="showApplyModal"
      :inquiry-id="inquiryId"
    />
    <gallery />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import DetailHeader from './Header'
import MemberModule from './MemberInfo'
import LeftTabs from './LeftTabs'
import RightTabs from './RightTabs'
import ApplyModal from './modal/ApplyModal'
import Gallery from '@/components/pc/Gallery'
import eventBus from '@/lib/eventBus'
import { getH } from '@/store/universalForm/convert'
import { setReplyPositionQuery } from '@/lib/before-router'

const FROM_SOPURCE = 'notice'

export default {
  components: {
    DetailHeader,
    MemberModule,
    LeftTabs,
    RightTabs,
    ApplyModal,
    Gallery
  },
  props: {

  },
  data () {
    return {
      showApplyModal: false,
      showCrumb: true,
      activeName: '',
      system_role: '',
      isFold: false
    }
  },
  computed: {
    ...mapState(['menuDatas']),
    ...mapState('inquery/detailData', [
      'loading',
      'detailData'
    ]),
    ...mapState('inquery/relateData', ['recycleLogTips']),
    ...mapGetters('inquery/detailData', [
      'formData',
      'permissionInfo'
    ]),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from || ''
    },
    type () {
      return this.$route.query.type
    },
    routeName () {
      return this.$route.name
    },
    code () {
      return (this.detailData && this.detailData.info && this.detailData.info.code) || ''
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    auditStatus () {
      const { info = {} } = this.detailData
      const { audit_status: auditStatus } = info
      return auditStatus
    },
    showPassTab () {
      let flag = false
      if (this.from === 'audit') {
        flag = false
      } else {
        if (this.auditStatus === 0 || this.auditStatus === -1) {
          flag = false
        } else if (this.auditStatus === 1) {
          flag = true
        }
      }
      return flag
    }
  },
  watch: {
    $route: {
      handler: async function (val, oldVal) {
        const { inquiryId: newInquiryId } = val.params
        const { inquiryId: oldInquiryId } = oldVal.params
        // console.log(newInquiryId, oldInquiryId)
        if (newInquiryId !== oldInquiryId) {
          await this.getDetail()
        }
      },
      // 深度观察监听
      deep: true
    },
    recycleLogTips: {
      handler () {
        this.getInnerHeight()
      },
      immediate: true
    }
  },
  beforeRouteEnter (to, from, next) {
    const { page } = to.query
    next(vm => {
      if (page === FROM_SOPURCE) {
        vm.showCrumb = false
      }
    })
  },
  async created () {
    await this.getDetail()
  },
  mounted () {
    eventBus.$on('fetchInquiryDetail', this.getDetail)
    eventBus.$on('getInnerHeight', this.getInnerHeight)
    // 获取询盘规则重置后的提示说明
    this.fetchRecycleLogTip({
      inquiryid: this.inquiryId
    })
  },
  beforeDestroy () {
    eventBus.$off('fetchInquiryDetail', this.getDetail)
    eventBus.$off('getInnerHeight', this.getInnerHeight)
  },
  destroyed () {
    this.UPDATA_DETAIL({})
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapActions('inquery/detailData', ['fetchDetail']),
    ...mapActions('inquery/relateData', ['fetchRecycleLogTip']),
    ...mapMutations('inquery/detailData', ['UPDATA_DETAIL', 'SET_LOADING']),
    getH,
    async getDetail (inquiryId, type) {
      const chain = await this.fetchDetail()
      chain
        .params({
          inquiryid: inquiryId || this.inquiryId,
          scope: this.from,
          checkrepeatfieldkey: this.checkrepeatfieldkey
        })
        .onFail((e, error) => {
          this.SET_LOADING(false)
        })
        .onNetSuccess((res = {}) => {
          this.setTitle(res)
          this.redirectRouter()
          this.$nextTick(() => {
            this.getInnerHeight()
          })
        })
        .fetch()
    },
    async setTitle (res) {
      let projectname, comname
      let { baseinfo = {} } = res.data || {}
      comname = baseinfo.comname
      projectname = baseinfo.projectname

      this.system_role = baseinfo.system_role
      const chain = await this.permissionMenu()
      chain.onSuccess(res => {
        const { permissionMenuList = {} } = this.menuDatas
        let parent = {}
        if (this.from === 'my') {
          parent = permissionMenuList['inquiry-mine']
        } else if (this.from === 'all') {
          parent = permissionMenuList['inquiry-all']
        } else if (this.from === 'audit') {
          parent = permissionMenuList['inquiry-audit']
        }
        let { child = {} } = parent || {}
        // console.log(this.type, child)
        let { name = '' } = (child && child[this.type]) || {}

        if (this.from === 'notice') {
          name = this.$t('message["1215"]')
        } else if (this.from === 'webhook') {
          name = '推送记录'
        } else if (this.from === 'clue') {
          name = '线索管理'
        }

        if (name) {
          document.title = name + '-' + projectname + '-' + comname
        } else {
          document.title = projectname + '-' + comname
        }
      })
    },
    redirectRouter () {
      const noticeQuery = setReplyPositionQuery()
      let routerName = ''
      // 如果 pc 打开移动端发送的 InqueryDetail 链接
      if ((this.auditStatus === 0 || this.auditStatus === -1) && this.$route.name === 'InqueryPassDetail') {
        routerName = 'InqueryDetail'
      } else if (this.auditStatus === 1 && (this.$route.name === 'InqueryDetail')) {
        routerName = 'InqueryPassDetail'
      }
      if (noticeQuery) {
        this.$router.push({ ...this.$route, name: routerName, query: noticeQuery })
      } else {
        this.$router.push({ ...this.$route, name: routerName })
      }
    },
    handleApply () {
      this.showApplyModal = true
    },
    async goBackList () {
      let { page, limit, viewid, issystem, _t } = this.$route.query
      let routeName = ''
      let linkName = {
        type: this.type,
        from: this.from,
        page,
        limit,
        _t
      }

      if (this.from === 'notice') {
        this.$router.push({ name: 'recordNotice' })
        return
      }
      if (this.from === 'audit') {
        routeName = 'InqueryAudit'
      } else if (this.from === 'my' || this.from === 'all') {
        routeName = 'InqueryList'
        linkName.viewid = viewid
        linkName.issystem = issystem
      } else if (this.from === 'checkrepeat') {
        routeName = 'InqueryRepeat'
      } else if (this.from === 'webhook') {
        routeName = 'configSendRecord'
      } else if (this.from === 'clue') {
        routeName = 'InqueryClue'
      } else if (this.from === 'ocpc') {
        routeName = 'ocpc'
      } else if (this.from === '') {
        routeName = 'InqueryList'
        // 1: 负责人, 2观察员, 3开发,4接待, 5销售 自定义为roleid
        switch (this.system_role) {
          case 1: // 负责人
          case 2: // 观察员
            linkName = { type: 'inquiry-manager-all', from: 'all' }
            break
          case 3: // 开发
            linkName = { type: 'inquiry-dev', from: 'my' }
            break
          case 4: // 接待
            linkName = { type: 'inquiry-add', from: 'my' }
            break
          case 5: // 销售
            linkName = { type: 'inquiry-followup', from: 'my' }
            break
          default: // 自定义角色
            let obj = await this.setCustomRoleRoute()
            routeName = obj.routeName || routeName
            linkName = obj.linkName
            break
        }
      }

      if (this.from === 'webhook') {
        this.$router.push({
          name: routeName,
          params: {
            hookid: this.$route.query.hookid
          }
        })
      } else if (this.from === 'clue') {
        this.$router.push({
          name: 'InqueryClue'
        })
      } else if (this.from === 'ocpc') {
        this.$router.push({
          name: 'ocpc'
        })
      } else {
        this.$router.push({
          name: routeName,
          query: linkName
        })
      }
    },
    async setCustomRoleRoute () {
      let linkName, routerName
      const chain = await this.permissionMenu() // 先请求菜单数据，判断自定义角色默认展示页
      return new Promise(async (resolve, reject) => {
        await chain
          .onSuccess(res => {
            for (let key in res) {
              if (key === 'inquiry-mine' && res[key]['state']) {
                let item = res[key]
                if ('child' in item) {
                  for (let cKey in item['child']) {
                    linkName = { type: cKey, from: 'my' }
                    break
                  }
                }
                break
              }
              if (key === 'inquiry-mine' && !res[key]['state']) {
                // console.log('查重： inquiry-check-repeat')
                routerName = 'InqueryRepeat'
                linkName = {}
                break
              }
            }
            resolve({ routerName, linkName })
          })
          .onNetFail(err => {
            reject(err)
          })
      })
    },
    getInnerHeight () {
      let $containerInner = this.$refs.containerInner
      let $memberModule = this.$refs.memberModule && this.$refs.memberModule.$el
      let $header = this.$refs.header && this.$refs.header.$el
      let $alert = this.$refs.alertRef
      if ($containerInner) {
        let memberModuleHeight = ($memberModule && $memberModule.offsetHeight) || 0
        let headerHeight = $header.offsetHeight + 16
        let alertHeight = $alert.offsetHeight
        if (this.recycleLogTips) {
          alertHeight = alertHeight || 40
        } else {
          alertHeight = 0
        }
        let h = memberModuleHeight + headerHeight + alertHeight + 16
        getH($containerInner, h)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.pass-detail {
  overflow-y: hidden;
  .container {
    width: 1280px;
    // height: calc(100vh - 94px);
    margin: 16px auto 0;
    border: solid 1px $gray4;
    border-radius: 5px;
    overflow: hidden;
    .inner {
      position: relative;
      width: 100%;
      overflow: hidden;
      transition: all 0.1s;
    }
  }
  .no-permission::v-deep {
    min-height: 700px;
    background: #fff;
    .member-module{
      border-bottom: none;
    }
  }
  .container-left {
    position: relative;
    &.fullContainer {
      width: 100%;
    }
    height: 100%;
    vertical-align: top;
    margin-right: 496px;
    padding: 0 40px;
    background-color: #fff;
    border-right: solid 1px $gray4;
  }
  .fold-btn {
    position: absolute;
    top: 50%;
    right: 0;
    width: 24px;
    height: 48px;
    margin-top: -24px;
    text-align: center;
    line-height: 48px;
    color: #fff;
    cursor: pointer;
    background-color: #e5e5e5;
    &.open {
      border-radius: 0;
      border-bottom-left-radius: 12px;
      border-top-left-radius: 12px;
    }
    &.close {
      right: -24px;
      border-radius: 0;
      border-bottom-right-radius: 12px;
      border-top-right-radius: 12px;
    }
  }
  .container-right {
    &.fullContainer {
      width: 100%;
    }
    float: right;
    width: 496px;
    height: 100%;
    padding: 0 40px;
    vertical-align: top;
    background-color: #fff;
  }
  .no_data {
    margin-top: 140px;
    .logo {
      font-size: 40px;
    }
    p {
      text-align: center;
      height: 24px;
      font-size: 15px;
      font-weight: 400;
      color: rgba(179, 179, 179, 1);
      line-height: 24px;
      margin-bottom: 8px;
    }
    .text {
      margin: 20px auto;
    }
  }
}
</style>
<style lang="scss">
.fold-box .ant-popover-inner-content {
  color: #ccc;
}
</style>
